import { accountIdFormat } from "@redotech/redo-account-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/** Merchants with the supplies storefront turned on, for discount allowlists. */
export const getSuppliesEnabledMerchants = unaryRpc({
  name: "getSuppliesEnabledMerchants" as const,
  input: z.object({}),
  output: z.object({
    merchants: z.array(
      z.object({ accountId: accountIdFormat.schema, name: z.string() }),
    ),
  }),
});
